module.exports = __webpack_public_path__ + "img/banner-live.f8a841d8.jpg";